import { useMutation } from '@tanstack/react-query';
import { IImpersonationContext, IOperationResultNoValue, ImpersonationBroker } from '../../extViewmodels';
import { WebsiteContent } from '../../extViewmodels/sdk/models/Website';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface Variables<T extends WebsiteContent> {
	websiteId: string;
	contentId: string;
	impersonationContext?: IImpersonationContext;
	content: T;
}

export function useUpdateWebsiteContentMutation<T extends WebsiteContent>({
	onSuccess,
	onError,
}: {
	onSuccess?: (content: WebsiteContent, params: Variables<T>) => void;
	onError?: (error: IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (params: Variables<T>) => {
			return userSession.webServiceHelper.callAsync<WebsiteContent>(
				ImpersonationBroker.composeApiUrl({
					urlPath: `website/${params.websiteId}/content/${params.contentId}`,
					impersonationContext: params.impersonationContext,
				}),
				'PUT',
				params.content
			);
		},
		onError,
		onSuccess,
	});
}
